import type { AlpineComponent } from 'alpinejs'

type FeedPost = {
  id: string
  permalink: string
  caption: string
  excerpt: string
  username: string
  src: string
  srcset: string
  width: number
  height: number
  videoUrl: string | null
}

export function SocialFeed(): AlpineComponent<{
  posts: FeedPost[]
  init(): Promise<void>
  scrollBy(direction: number): void
}> {
  return {
    posts: [],
    async init() {
      const endpoint = this.$el.dataset.endpoint ?? '/social-feed.json'

      try {
        const response = await fetch(endpoint)
        const data = await response.json()
        this.posts = (data.posts ?? []) as FeedPost[]
      } catch (error) {
        console.error('Social feed failed to load:', error)
      }
    },

    scrollBy(direction: number) {
      const scroller = this.$refs.scroller as HTMLElement | undefined
      if (!scroller) return

      const slide = scroller.querySelector('[data-slide]') as HTMLElement | null
      const amount = slide?.getBoundingClientRect().width ?? scroller.clientWidth / 3
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' })
    },
  }
}
